import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab17',
  templateUrl: './awsop-lab17.component.html',
  styleUrls: ['./awsop-lab17.component.css']
})
export class AwsopLab17Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab17/awsop-lab17.component.ts